import { ensure, stringType, TType } from "types";

export enum TBannerVisibility {
  VISIBLE = "VISIBLE",
  HIDDEN = "HIDDEN",
  PUBLIC_ONLY = "PUBLIC_ONLY",
  AUTHORIZED_ONLY = "AUTHORIZED_ONLY",
}

export interface IBanner {
  text: string;
  icon: string;
  backgroundColor: string;
  textAndIconColor: string;
  visibility: TBannerVisibility | null;
}

export const configBannerType: TType<IBanner> = {
  text: stringType(""),
  icon: stringType(""),
  backgroundColor: stringType("#000000"),
  textAndIconColor: stringType("#FFFFFF"),
  visibility: stringType(null),
};

export const bannerType = ensure(configBannerType);
